<template>
  <span class="flex shrink-0 gap-6" aria-hidden="true">
    <span
      v-for="index in COUNT"
      :key="index"
      class="rounded-full h-8 w-8 outline outline-1 outline-offset-0 outline-[color-mix(in_oklab,black_15%,transparent)]"
      :class="
        index <= score
          ? 'bg-[var(--score-fill,var(--raw-red))]'
          : 'bg-[color-mix(in_oklab,black_10%,transparent)]'
      "
    />
  </span>
</template>

<script setup lang="ts">
import type { Score5 } from '~/scopes/campaign/data/metals/types'

defineProps<{ score: Score5 }>()

const COUNT = 5

// Notes live here, not beside the root: a sibling comment makes the render root a
// fragment and breaks `<Transition>`.
//
// Hosts retone the filled dots through `--score-fill` (red by default, white for
// recycling and smartphone quantity), so the outline is what keeps them defined.
</script>
